import $ from 'jquery';

global.$ = $;
global.jQuery = $;

// initial trigger dom inits todo: talk about this
//$(() => $(document).trigger('e2-dom-init', [$('body')]));
